import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { formatCurrency } from '../../../../helpers/numbers'

import { selectedGoogleAdAccountSelector } from '../../../../modules/selectors/adAccounts'

const BudgetDailySectionPreview = ({ budgetDaily }) => {
  const { t } = useTranslation()

  const { currency_symbol } = useSelector(selectedGoogleAdAccountSelector)

  const formattedBudget = useMemo(
    () => formatCurrency(budgetDaily, { min: 2, max: 2 }, { symbol: currency_symbol }),
    [budgetDaily, currency_symbol]
  )

  return (
    <p>
      {formattedBudget} ({t('Daily')})
    </p>
  )
}

export default BudgetDailySectionPreview
